import React, { FC } from 'react'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import { MeansOfCommunicationContainer } from '../styles/MeanOfCommunicationSkeleton.styles'
import { MeanOfCommunicationSkeletonView } from './MeanOfCommunicationSkeletonView'

export const MeanOfCommunicationSkeleton: FC = () => (
  <MeansOfCommunicationContainer>
    <Skeleton width="10rem" height="1.5rem" />{' '}
    <section>
      <MeanOfCommunicationSkeletonView />
      <MeanOfCommunicationSkeletonView />
      <MeanOfCommunicationSkeletonView />
      <MeanOfCommunicationSkeletonView />
    </section>
  </MeansOfCommunicationContainer>
)
